export default {
  "config": {
    "trial": "tones-3",
    "id": "cpap-adh",
    "type": "table",
    "title": "Evaluation of Solriamfetol on Primary OSA Therapy Device Use<no-break><sup>22</sup><sup>,a</sup></no-break>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "*Combined doses includes solriamfetol 37.5 mg, 75 mg, 150 mg, and 300 mg.",
      "For participants with electronically retrievable data, missing data on primary OSA therapy device use were imputed by LOCF within each period. For participants with diary data only, only nonmissing data were summarized and there was no imputation method used for missing data.",
      "<sup>a</sup>Primary OSA therapy devices included use of PAP, oral pressure therapy, oral appliance, or upper airway stimulator.",
      "<sup>b</sup>Number of participants in mITT population placebo group using a primary OSA therapy device at baseline.",
      "<sup>c</sup>Number of participants in mITT population combined solriamfetol group using a primary OSA therapy device at baseline.",
      "<sup>d</sup>Includes all participants using a primary OSA therapy device at baseline (electronically downloadable and diary data).",
      "<sup>e</sup>Based on average use during the time period between the screening and baseline visits <no-break>(≤29 days).</no-break>",
      "<sup>f</sup><no-break><em>P</em> > 0.05</no-break> for combined solriamfetol vs placebo and for each solriamfetol dose group vs placebo (data not shown) (Wilcoxon rank-sum test).",
      "<sup>g</sup>Based on use by participants with electronically downloadable data only.",
      "<sup>h</sup>Based on use recorded in diary (for participants without electronically downloadable data; only participants with nonmissing diary data are summarized)."
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "tones-3",
    "id": "cpap-adh",
    "data-type": "table",
    "title": "Evaluation of Solriamfetol on Primary OSA Therapy Device Use<no-break><sup>22</sup><sup>,a</sup></no-break>",
    "num-header-rows": 2,
    "num-columns": 5,
    "col-classes": [
      "col-1",
      "pbo",
      "pbo",
      "sol",
      "sol"
    ],
    "row-mergeoption": [
      1,
      2,
      3,
      8,
      13
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-note1",
      "footnote-note2",
      "footnote-note3",
      "footnote-a",
      "footnote-b",
      "footnote-c",
      "footnote-d",
      "footnote-e",
      "footnote-f",
      "footnote-g",
      "footnote-h"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "footnote-note2": "*Combined doses includes solriamfetol 37.5 mg, 75 mg, 150 mg, and 300 mg.",
    "footnote-note3": "For participants with electronically retrievable data, missing data on primary OSA therapy device use were imputed by LOCF within each period. For participants with diary data only, only nonmissing data were summarized and there was no imputation method used for missing data.",
    "footnote-a": "<sup>a</sup>Primary OSA therapy devices included use of PAP, oral pressure therapy, oral appliance, or upper airway stimulator.",
    "footnote-b": "<sup>b</sup>Number of participants in mITT population placebo group using a primary OSA therapy device at baseline.",
    "footnote-c": "<sup>c</sup>Number of participants in mITT population combined solriamfetol group using a primary OSA therapy device at baseline.",
    "footnote-d": "<sup>d</sup>Includes all participants using a primary OSA therapy device at baseline (electronically downloadable and diary data).",
    "footnote-e": "<sup>e</sup>Based on average use during the time period between the screening and baseline visits <no-break>(≤29 days).</no-break>",
    "footnote-f": "<sup>f</sup><no-break><em>P</em> > 0.05</no-break> for combined solriamfetol vs placebo and for each solriamfetol dose group vs placebo (data not shown) (Wilcoxon rank-sum test).",
    "footnote-g": "<sup>g</sup>Based on use by participants with electronically downloadable data only.",
    "footnote-h": "<sup>h</sup>Based on use recorded in diary (for participants without electronically downloadable data; only participants with nonmissing diary data are summarized).",
    "data": {
      "row-0": [
        {
          "content": null,
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>Placebo<br><no-break>(n = 81<sup>b</sup>)</no-break></b></center>",
          "cols": 2,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<center><b>Solriamfetol (combined)*<br><no-break>(n = 255<sup>c</sup>)</no-break></b></center>",
          "cols": 2,
          "class": "sol"
        }
      ],
      "row-1": [
        {
          "content": null,
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>Median<br><no-break>(Q1, Q3)</no-break></b>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<b>n</b>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<b>Median<br><no-break>(Q1, Q3)</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>n</b>",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "<b>Primary OSA therapy device <no-break>usage, % of nights<sup>d</sup></no-break><b>",
          "cols": 5,
          "class": "col-1",
          "parentRow": true,
          "parent": 2
        }
      ],
      "row-3": [
        {
          "indent": 1,
          "parent": 2,
          "content": "Baseline<sup>e</sup>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "100.0 (87.5, 100.0)",
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 81,
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "100.0 (88.9, 100.0)",
          "parent": 2,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 255,
          "parent": 2,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-4": [
        {
          "indent": 1,
          "parent": 2,
          "content": "Change weeks <no-break>1-4<sup>f</sup></no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "0 <no-break>(–1.4,</no-break> 4.2)",
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 79,
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "0 (0, 3.7)",
          "parent": 2,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 251,
          "parent": 2,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-5": [
        {
          "indent": 1,
          "parent": 2,
          "content": "Change weeks <no-break>5-8<sup>f</sup></no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "0 (0, 4.2)",
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 75,
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "0 (0.0, 5.2)",
          "parent": 2,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 223,
          "parent": 2,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-6": [
        {
          "indent": 1,
          "parent": 2,
          "content": "Change weeks <no-break>9-12<sup>f</sup></no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "0 (0, 4.2)",
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 69,
          "parent": 2,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "0 (0, 3.3)",
          "parent": 2,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 218,
          "parent": 2,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-7": [
        {
          "indent": 0,
          "content": "<b>Primary OSA therapy device <no-break>usage, h per night<sup>g</sup></no-break>",
          "cols": 5,
          "class": "col-1",
          "parentRow": true,
          "parent": 7
        }
      ],
      "row-8": [
        {
          "indent": 1,
          "parent": 7,
          "content": "Baseline<sup>e</sup>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "6.8 (6.0, 7.3)",
          "parent": 7,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 53,
          "parent": 7,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "6.5 (5.7, 7.4)",
          "parent": 7,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 157,
          "parent": 7,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-9": [
        {
          "indent": 1,
          "parent": 7,
          "content": "Change weeks <no-break>1-4<sup>f</sup></no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.1</no-break> <no-break>(–0.2,</no-break> 0.2)",
          "parent": 7,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 51,
          "parent": 7,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.1</no-break> <no-break>(–0.6,</no-break> 0.3)",
          "parent": 7,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 152,
          "parent": 7,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-10": [
        {
          "indent": 1,
          "parent": 7,
          "content": "Change weeks <no-break>5-8<sup>f</sup></no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.3</no-break> <no-break>(–0.8,</no-break> 0.3)",
          "parent": 7,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 45,
          "parent": 7,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.2</no-break> <no-break>(–0.6,</no-break> 0.3)",
          "parent": 7,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 132,
          "parent": 7,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-11": [
        {
          "indent": 1,
          "parent": 7,
          "content": "Change weeks <no-break>9-12<sup>f</sup></no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.4</no-break> <no-break>(–0.8,</no-break> 0.4)",
          "parent": 7,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 43,
          "parent": 7,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.2</no-break> <no-break>(–0.8,</no-break> 0.3)",
          "parent": 7,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 133,
          "parent": 7,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-12": [
        {
          "indent": 0,
          "content": "<b>Primary OSA therapy device used for more than half the <no-break>night, %<sup>h</sup></no-break><b>",
          "cols": 5,
          "class": "col-1",
          "parentRow": true,
          "parent": 12
        }
      ],
      "row-13": [
        {
          "indent": 1,
          "parent": 12,
          "content": "Baseline",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "100 (100, 100)",
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 28,
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "100 (100, 100)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 100,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-14": [
        {
          "indent": 1,
          "parent": 12,
          "content": "Change weeks <no-break>1-4<sup>f</sup></no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "0 (0, 0)",
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 28,
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "0 (0, 0)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 99,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-15": [
        {
          "indent": 1,
          "parent": 12,
          "content": "Change weeks <no-break>5-8<sup>f</sup></no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "0 (0, 0)",
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 28,
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "0 (0, 0)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 91,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-16": [
        {
          "indent": 1,
          "parent": 12,
          "content": "Change weeks <no-break>9-12<sup>f</sup></no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "0 (0, 0)",
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 24,
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "0 (0, 0)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": 84,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ]
    }
  }
};